import { createFileRoute, redirect } from "@tanstack/react-router";
import { MANAGEMENT_ROUTES } from "@/utils/navigation";

export const Route = createFileRoute("/(protected)/management/")({
  beforeLoad: () => {
    throw redirect({
      to: MANAGEMENT_ROUTES.MANAGEMENT_DASHBOARD,
    });
  },
});
